// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/DroidSans-Bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/DroidSans-webfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "droid_sansbold";
  src: local("DroidSans-Bold-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "droid_sansregular";
  src: local("DroidSans-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

ul[role=list],
ol[role=list] {
  list-style: none;
}

html:focus-within {
  scroll-behavior: smooth;
}

a:not([class]) {
  text-decoration-skip-ink: auto;
}

img,
picture,
svg,
video,
canvas {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  font-style: italic;
  background-repeat: no-repeat;
  background-size: cover;
}

input,
button,
textarea,
select {
  font: inherit;
}

@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition: none;
  }
}
body,
html {
  height: 100%;
  scroll-behavior: smooth;
}

.subtitle {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  display: flex;
  justify-content: flex-start;
  color: #2f2f2f;
  font-weight: 600;
}

.insights-filter {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);
  display: flex;
  flex-direction: column;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.13);
  border: 1px solid rgba(0, 0, 0, 0.14);
  padding: 1rem;
}

.insights-project-filter {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 0.5rem;
}
.insights-project-filter .form-select {
  max-width: 14.2857142857%;
  font-family: "Poppins", sans-serif !important;
}
.insights-project-filter .range-filter {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;
}
.insights-project-filter .range-filter .form-label {
  white-space: nowrap;
}
.insights-project-filter .multi-select-dropdown .select-header {
  padding: 0 6px;
}
.insights-project-filter .btn-primary {
  padding-left: 3rem;
  padding-right: 3rem;
}

.scores-charts {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}

.chart-title {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 0.875rem;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.scores-container {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  gap: 1rem;
}

.no-data {
  color: #2f2f2f;
  display: block;
  margin: 0 auto;
  text-align: center;
}

.select-container {
  display: flex;
  gap: 0.875rem;
}

.table-title {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background: rgb(255, 255, 255);
  background: linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(239, 240, 241) 100%);
  display: flex;
  justify-content: space-between;
  color: #0d47a0;
  padding: 12px 16px;
  font-size: 1rem;
  border: 1px solid #e9e9e9;
  border-radius: 6px;
  margin: 12px 0;
}

.table-title-normal {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background: rgb(255, 255, 255);
  background: linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(239, 240, 241) 100%);
  display: flex;
  justify-content: space-between;
  color: #0d47a0;
  padding: 12px 16px;
  font-size: 1rem;
  border: 1px solid #eff0f1;
  border-radius: 6px 6px 0 0;
  margin: 12px 0 0;
}

.icon-colors {
  color: #093373;
  font-size: 24px;
}

.project-scores {
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
  font-size: 0.875rem;
  color: #2f2f2f;
  line-height: 1.2;
}
.project-scores .table-project-title {
  font-size: 0.75rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}
.project-scores .table-project-score {
  display: flex;
  justify-content: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  font-weight: 600;
}
.project-scores .table-project-score .title-projectName {
  font-size: 0.875rem;
  font-weight: 400;
}

.brand-norm-table thead th,
.brand-norm-table tbody td {
  width: 10%;
  text-align: center; /* Optional: to align text in the center */
  word-break: break-word; /* Optional: to handle long text gracefully */
}

.insight-export {
  position: relative;
}
.insight-export button {
  position: absolute;
  top: 0;
  right: 0;
}

@media (max-width: 767px) {
  .insights-project-filter {
    flex-direction: column;
  }
  .scores-charts {
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.13);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/mixins/fonts.scss","webpack://./src/pages/insights/Insights.scss","webpack://./src/assets/mixins/reset.scss","webpack://./src/assets/mixins/colors.scss","webpack://./src/assets/mixins/mixins.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,oGAAA;EAEA,mBAAA;EACA,kBAAA;ACAF;ADEA;EACE,gCAAA;EACA,+FAAA;EAEA,mBAAA;EACA,kBAAA;ACDF;ACbA;;;EAGE,sBAAA;ADeF;;ACZA;EACE,SAAA;EACA,UAAA;ADeF;;ACZA;;EAEE,gBAAA;ADeF;;ACZA;EACE,uBAAA;ADeF;;ACZA;EACE,8BAAA;ADeF;;ACZA;;;;;EAKE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;ADeF;;ACZA;;;;EAIE,aAAA;ADeF;;ACZA;EACE;IACE,qBAAA;EDeF;ECbA;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;IACA,gBAAA;EDeF;AACF;ACZA;;EAEE,YAAA;EACA,uBAAA;ADcF;;AA1EA;ED0BE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC3BA,aAAA;EACA,2BAAA;EACA,cEDW;EFEX,gBAAA;AAgFF;;AA5EA;EGRE,sBDCM;ECAN,qBAAA;EACA,wCAAA;EHQA,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,qCAAA;EACA,aAAA;AAiFF;;AA/EA;EACE,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,WAAA;AAkFF;AAjFE;EACE,yBAAA;EACA,6CAAA;AAmFJ;AAjFE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;AAmFJ;AAlFI;EACE,mBAAA;AAoFN;AAhFI;EACE,cAAA;AAkFN;AA/EE;EACE,kBAAA;EACA,mBAAA;AAiFJ;;AA7EA;EG7CE,sBDCM;ECAN,qBAAA;EACA,wCAAA;EH6CA,qBAAA;EACA,aAAA;EACA,sBAAA;AAkFF;;AAhFA;ED1BE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECyBA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AAsFF;;AApFA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAuFF;;AArFA;EACE,cEhEW;EFiEX,cAAA;EACA,cAAA;EACA,kBAAA;AAwFF;;AAtFA;EACE,aAAA;EACA,aAAA;AAyFF;;AAvFA;EDlDE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECiDA,8BAAA;EACA,mFAAA;EAKA,aAAA;EACA,8BAAA;EACA,cExFc;EFyFd,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAyFF;;AAvFA;EDnEE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECkEA,8BAAA;EACA,mFAAA;EAKA,aAAA;EACA,8BAAA;EACA,cEzGc;EF0Gd,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;AAyFF;;AAtFA;EACE,cEjHoB;EFkHpB,eAAA;AAyFF;;AAvFA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cErHW;EFsHX,gBAAA;AA0FF;AAzFE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;AA2FJ;AAzFE;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AA2FJ;AA1FI;EACE,mBAAA;EACA,gBAAA;AA4FN;;AAxFA;;EAEE,UAAA;EACA,kBAAA,EAAA,0CAAA;EACA,sBAAA,EAAA,6CAAA;AA2FF;;AAzFA;EACE,kBAAA;AA4FF;AA3FE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AA6FJ;;AAzFA;EACE;IACE,sBAAA;EA4FF;EA1FA;IACE,uCAAA;EA4FF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@font-face {\r\n  font-family: \"droid_sansbold\";\r\n  src: local(\"DroidSans-Bold-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: \"droid_sansregular\";\r\n  src: local(\"DroidSans-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@mixin primeFont() {\r\n  font-family: \"Abril Fatface\", serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFont() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFontBold() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n","@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@font-face {\n  font-family: \"droid_sansbold\";\n  src: local(\"DroidSans-Bold-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"droid_sansregular\";\n  src: local(\"DroidSans-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\nul[role=list],\nol[role=list] {\n  list-style: none;\n}\n\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\nimg,\npicture,\nsvg,\nvideo,\ncanvas {\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n  font-style: italic;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n    transition: none;\n  }\n}\nbody,\nhtml {\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\n.subtitle {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  display: flex;\n  justify-content: flex-start;\n  color: #2f2f2f;\n  font-weight: 600;\n}\n\n.insights-filter {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.13);\n  border: 1px solid rgba(0, 0, 0, 0.14);\n  padding: 1rem;\n}\n\n.insights-project-filter {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-start;\n  gap: 0.5rem;\n}\n.insights-project-filter .form-select {\n  max-width: 14.2857142857%;\n  font-family: \"Poppins\", sans-serif !important;\n}\n.insights-project-filter .range-filter {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  justify-content: flex-end;\n}\n.insights-project-filter .range-filter .form-label {\n  white-space: nowrap;\n}\n.insights-project-filter .multi-select-dropdown .select-header {\n  padding: 0 6px;\n}\n.insights-project-filter .btn-primary {\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n\n.scores-charts {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);\n  margin-bottom: 1.5rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.chart-title {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 0.875rem;\n  padding: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n}\n\n.scores-container {\n  width: 100%;\n  display: flex;\n  flex-flow: row wrap;\n  gap: 1rem;\n}\n\n.no-data {\n  color: #2f2f2f;\n  display: block;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.select-container {\n  display: flex;\n  gap: 0.875rem;\n}\n\n.table-title {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  background: rgb(255, 255, 255);\n  background: linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(239, 240, 241) 100%);\n  display: flex;\n  justify-content: space-between;\n  color: #0d47a0;\n  padding: 12px 16px;\n  font-size: 1rem;\n  border: 1px solid #e9e9e9;\n  border-radius: 6px;\n  margin: 12px 0;\n}\n\n.table-title-normal {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  background: rgb(255, 255, 255);\n  background: linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(239, 240, 241) 100%);\n  display: flex;\n  justify-content: space-between;\n  color: #0d47a0;\n  padding: 12px 16px;\n  font-size: 1rem;\n  border: 1px solid #eff0f1;\n  border-radius: 6px 6px 0 0;\n  margin: 12px 0 0;\n}\n\n.icon-colors {\n  color: #093373;\n  font-size: 24px;\n}\n\n.project-scores {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 6px;\n  font-size: 0.875rem;\n  color: #2f2f2f;\n  line-height: 1.2;\n}\n.project-scores .table-project-title {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.6);\n}\n.project-scores .table-project-score {\n  display: flex;\n  justify-content: center;\n  gap: 0.25rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n.project-scores .table-project-score .title-projectName {\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n.brand-norm-table thead th,\n.brand-norm-table tbody td {\n  width: 10%;\n  text-align: center; /* Optional: to align text in the center */\n  word-break: break-word; /* Optional: to handle long text gracefully */\n}\n\n.insight-export {\n  position: relative;\n}\n.insight-export button {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n@media (max-width: 767px) {\n  .insights-project-filter {\n    flex-direction: column;\n  }\n  .scores-charts {\n    box-shadow: 0 0 6px rgba(0, 0, 0, 0.13);\n  }\n}","*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul[role=\"list\"],\r\nol[role=\"list\"] {\r\n  list-style: none;\r\n}\r\n\r\nhtml:focus-within {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\na:not([class]) {\r\n  text-decoration-skip-ink: auto;\r\n}\r\n\r\nimg,\r\npicture,\r\nsvg,\r\nvideo,\r\ncanvas {\r\n  max-width: 100%;\r\n  height: auto;\r\n  vertical-align: middle;\r\n  font-style: italic;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  html:focus-within {\r\n    scroll-behavior: auto;\r\n  }\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n    transition: none;\r\n  }\r\n}\r\n\r\nbody,\r\nhtml {\r\n  height: 100%;\r\n  scroll-behavior: smooth;\r\n}\r\n","$primary-color: #0d47a0;\r\n$primary-color-hover: #093373;\r\n$secondary-blue: #93cfff;\r\n$background-color: #f4f6fa;\r\n$white: #fff;\r\n$text-color: #2f2f2f;\r\n$text-dark-color: #072148;\r\n$table-stroke-color: #dfdfdf;\r\n$stroke-color: #949494;\r\n$input-stroke: #e4e8e9;\r\n$text-warning: #ed8b00;\r\n$text-danger: #cc3201;\r\n$text-success: #339900;\r\n$tooltip-bg: #0d47a0;\r\n$tooltip-color: #ffffff;\r\n$button-color: #ff6b00;\r\n","@import \"variables\", \"colors\", \"fonts\", \"reset\";\r\n\r\n@mixin boxWithShadow() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 13%);\r\n}\r\n@mixin brandScores() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 12%);\r\n  padding: 0.675rem;\r\n}\r\n\r\n@mixin pageTitle() {\r\n  @include primeFont();\r\n  font-size: 2rem;\r\n  color: $primary-color;\r\n  line-height: 2.5rem;\r\n  margin-top: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n@mixin boxSubTitle() {\r\n  @include secondaryFontBold;\r\n  font-size: 1rem;\r\n  color: $text-color;\r\n  line-height: 1.2;\r\n  margin-bottom: .875rem;\r\n  display: flex;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
